import React from 'react';
import { Image } from 'antd';
import { nameBuilder } from 'common/helpers/name.helper';
import { dateFormatter } from 'common/helpers/date.helper';
import { DATE_FORMAT_WITH_TIME } from 'common/const/common.const';
import { IStoreModel } from 'entities/Store/Store.models';
import { IUserModel } from 'entities/User/User.models';

export interface IAnnouncementCollectionFilter extends Paths.AnnouncementControllerList.QueryParameters {
  pageIndex?: number;
}
export interface IAnnouncementCollection extends Components.Schemas.AnnouncementCollectionDto {}


export interface IAnnouncementCreateData extends Components.Schemas.CreateAnnouncementDto {}
export interface IAnnouncementUpdateData extends Components.Schemas.UpdateAnnouncementDto {
  id: string;
}
// Local isHidden override until `yarn models:build` regenerates the API types (MB pattern).
export interface IAnnouncementModel extends Components.Schemas.AnnouncementDto {
  isHidden?: boolean;
}

export enum EAnnouncementStatus {
  Active = 'active',
  Expired = 'expired',
  Pending = 'pending',
}
export enum EAnnouncementStatusText {
  Active = 'Active',
  Expired = 'Expired',
  Pending = 'Pending',
}

export enum EAnnouncementSuccessMessage {
  Delete = 'Announcement has been successfully deleted',
  Create = 'Announcement has been successfully created',
  Edit = 'Announcement has been successfully edited',
  Hidden = 'Announcement has been unpublished — it is hidden from customers and can be edited',
  Published = 'Announcement has been published back',
}

export const announcementTableConfig = [
  {
    key: 'name',
    dataIndex: 'name',
    title: 'Name',
  },
  {
    key: 'image',
    dataIndex: 'image',
    title: 'Image',
    width: '120px',
    render: (image: string) => (image ? <Image src={`/api/images/${image}`} /> : null),
  },
  {
    key: 'status',
    title: 'Status',
    // Render the BE-computed status (single source of truth) — no client recompute.
    // Hidden announcements report `pending`; the suffix tells them apart from not-yet-started.
    // Expired wins over hidden (BE computes it that way) — show plain `expired`, no suffix.
    render: (_: any, record: IAnnouncementModel) =>
      record.isHidden && record.status !== EAnnouncementStatus.Expired ? `${record.status} (hidden)` : record.status,
    onCell: () => ({ className: 't-transform-c' }),
  },
  {
    key: 'startDate',
    dataIndex: 'startDate',
    title: 'Start date',
    width: 175,
    render: (value: string) => dateFormatter(value, DATE_FORMAT_WITH_TIME),
  },
  {
    key: 'endDate',
    dataIndex: 'endDate',
    title: 'End date',
    width: 175,
    render: (value: string) => dateFormatter(value, DATE_FORMAT_WITH_TIME),
  },
  {
    key: 'stores',
    dataIndex: 'stores',
    title: 'Stores',
    render: (value: IStoreModel[]) => {
      if (!value || !value.length) {
        return 'All stores';
      }

      return value.map((item: any) => item.storeName).join(', ');
    },
  },
  {
    key: 'franchisor',
    dataIndex: 'franchisor',
    title: 'Franchisor',
    render: (value: IUserModel) => nameBuilder(value.firstName, value.lastName),
  },
];
